import superUserMiddleware from "./superUser";

const middleware = [superUserMiddleware];

export default middleware;
